import React from 'react';

// utils
import { toCurrency, toDecimal } from '@/utils/numberFormatter';

const pnlColor = (sign, value) => {
  const res: { color?: string } = {};

  if (!sign) {
    return {};
  }
  if (value > 0) {
    res.color = '#1FC090';
  } else if (value < 0) {
    res.color = '#E54949';
  }

  return res;
};

export default function NumberFormat({
  value,
  digit = 2,
  type,
  sign,
  currency,
  ...rest
}: {
  value: number;
  digit?: number;
  type: string;
  sign?: Boolean;
  currency?: string;
}) {
  if (type !== 'currency') {
    return (
      <>
        {sign && value > 0 && '+'}
        <span {...rest}>
          {value !== 0 ? `${toDecimal(value, digit)} ${type === 'percent' ? '%' : ''}` : '-'}
        </span>
      </>
    );
  }

  return (
    <>
      <span style={pnlColor(sign, value)} data-secret-mode="active" {...rest}>
        {sign && value > 0 && '+'}
        {toCurrency(value, currency, digit)}
      </span>
    </>
  );
}
